import Vuex from 'vuex';
import Vue from 'vue';
import CoreStore from '@/core/store';
import LoanStore from '@/loan/store';
import ProfileStore from '@/profile/store';
import HelpCenterStore from '@/help-center/store';
import LoginStore from '@/login/store';

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		core: CoreStore,
		helpCenter: HelpCenterStore,
		loan: LoanStore,
		login: LoginStore,
		profile: ProfileStore,
	},
});
